import { fetcher } from "helpers/fetcher";

import {
  TUpdateJobListingExperienceReq,
  TUpdateJobListingRequirementsRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const updateJobListingExperience = async (
  payload: TUpdateJobListingExperienceReq
) => {
  return await fetcher<
    TUpdateJobListingRequirementsRes,
    TUpdateJobListingExperienceReq["data"]
  >(ENDPOINT.CORPORATION.UPDATE_JOB_LISTING_EXPERIENCE, {
    data: payload.data,
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.CORPORATION.UPDATE_JOB_LISTING_EXPERIENCE.version,
      [API_HEADER.CORP_ID]: payload.idCorp,
    },
  });
};

export const mutationUpdateJobListingExperience = async (
  payload: TUpdateJobListingExperienceReq
) => {
  return (await updateJobListingExperience(payload)).data;
};

mutationUpdateJobListingExperience._key = (
  payload: TUpdateJobListingExperienceReq
) => [ENDPOINT.CORPORATION.UPDATE_JOB_LISTING_EXPERIENCE.url, payload];
